var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13c4.083 0 7 2.4 7 4.2V19H1v-1.8C1 15.4 3.917 13 8 13Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.2c0-1.317-1.562-2.956-4-3.74a9.8 9.8 0 0 1 3-.46c4.083 0 7 2.4 7 4.2V19h-6v-1.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGroup);
export default __webpack_public_path__ + "static/media/ic_group.2e9410c5549d821169a3aff448cdb906.svg";
export { ForwardRef as ReactComponent };